// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Asset Allocation",
    titleHelp: "Optional heading to display above the asset allocation",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showChart: "Show Chart",
    showChartHelp: "Display pie chart visualization",
    showTable: "Show Table",
    showTableHelp: "Display data table with color indicators",
    enableFollowupComparison: "Enable comparison in follow up sessions",
    enableFollowupComparisonHelp:
      "Show existing vs modified portfolio side-by-side when the session is a followup",
    validationError: "At least one display option must be selected",
    validationErrorLong: "At least one display option (Chart or Table) must be selected",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Aktivaallokering",
    titleHelp: "Valgfri overskrift som vises over aktivaallokeringen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showChart: "Vis diagram",
    showChartHelp: "Vis sektordiagram",
    showTable: "Vis tabell",
    showTableHelp: "Vis datatabell med fargeindikatorer",
    enableFollowupComparison: "Aktiver sammenligning i oppfølgingsøkter",
    enableFollowupComparisonHelp:
      "Vis eksisterende og endret portefølje side om side når økten er en oppfølging",
    validationError: "Minst ett visningsalternativ må være valgt",
    validationErrorLong: "Minst ett visningsalternativ (diagram eller tabell) må være valgt",
  },
} as const;
